import React, { Component } from "react";
import PropTypes from "prop-types";
import Form from "./AdicionalCreateForm";
import LoadMask from "Utils/LoadMask/LoadMask";

export default class AdicionalCreate extends Component {
    static propTypes = {
        loader: PropTypes.bool.isRequired,
        crear: PropTypes.func.isRequired,
    };
    constructor(props) {
        super(props);
        this.state = {
            id: null,
        };
    }
    componentWillMount() {
        const id = this.props.match.params.id;
        if (id) {
            this.props.leer(this.props.match.params.id);
            this.setState({ id });
        } else {
            this.setState({ id: null });
        }
    }

    render() {
        // state
        const { loader } = this.props;
        const { id } = this.state;

        // bind
        const { crear, editar } = this.props;

        return (
            <div className="row">
                <div className="col-sm-12">
                    <LoadMask loading={loader} light blur radius>
                        <div className="form-group grid-container">
                            <div className="grid-titulo padding-15">
                                {id ? "Editar Adicional" : "Nuevo Adicional"}
                            </div>
                            <div className="">
                                <Form onSubmit={id ? editar : crear} />
                            </div>
                        </div>
                    </LoadMask>
                </div>
            </div>
        );
    }
}
